import useCapabilities from "@/hooks/useCapabilities";
import { useFlags } from "@/hooks/useFeatureFlags";
import TasksTabContent from "../../_components/TasksTabContent";

export default function MyTasksPage() {
  const { id: currentUserId } = useCapabilities();
  const flags = useFlags();
  const teamsEnabled = !!flags["m360-department-task-queue"];

  return (
    <TasksTabContent
      body={
        teamsEnabled
          ? "View and manage tasks assigned to me or unassigned tasks I created"
          : "View and manage all tasks assigned to me"
      }
      source="my_tasks_tab"
      queryOptions={
        teamsEnabled ? { myTasks: true, showUnassignedChip: true } : { fixedUserId: currentUserId || undefined }
      }
      hideUserChips
    />
  );
}
